import { Component } from '@angular/core';
import { JOB_AZ_CHECK_CATEGORY_OPTIONS, JobCategory } from '@agent-ds/shared/interfaces/job-az-check';
import { JobAzCheckService } from '../../services/job-az-check.service';

@Component({
  selector: 'ag-job-az-check-step-select-category',
  templateUrl: './job-az-check-step-select-category.component.html',
  styleUrls: ['./job-az-check-step-select-category.component.scss'],
})
export class JobAzCheckStepSelectCategoryComponent {
  readonly jobAzCheckCategoryOptions = JOB_AZ_CHECK_CATEGORY_OPTIONS;

  selectedJobCategory: JobCategory;

  constructor(public jobAzCheckService: JobAzCheckService) {
    this.selectedJobCategory = jobAzCheckService.job.dynamicData.jobCompanyAzCheckCategory;
  }
}
